import { initRequest } from './request.js';

const restApi = initRequest(process.env.BACKEND_API);

export async function findList() {
  return restApi.post('/occo-owner/organisation/list/retrieve', {}, { addAuth: true }).then((response) => {
    if (response.status === 'nok') return Promise.reject(response.error);
    return response.result?.organisations ?? [];
  });
}
